import { createSlice } from '@reduxjs/toolkit';

const emptyPicks = {
  A1: { id: 'A1', teamId: null },
  A2: { id: 'A2', teamId: null },
  B1: { id: 'B1', teamId: null },
  B2: { id: 'B2', teamId: null },
  C1: { id: 'C1', teamId: null },
  C2: { id: 'C2', teamId: null },
  D1: { id: 'D1', teamId: null },
  D2: { id: 'D2', teamId: null },
  E1: { id: 'E1', teamId: null },
  E2: { id: 'E2', teamId: null },
  F1: { id: 'F1', teamId: null },
  F2: { id: 'F2', teamId: null },
  G1: { id: 'G1', teamId: null },
  G2: { id: 'G2', teamId: null },
  H1: { id: 'H1', teamId: null },
  H2: { id: 'H2', teamId: null },
  W49: { id: 'W49', teamId: null },
  W50: { id: 'W50', teamId: null },
  W51: { id: 'W51', teamId: null },
  W52: { id: 'W52', teamId: null },
  W53: { id: 'W53', teamId: null },
  W54: { id: 'W54', teamId: null },
  W55: { id: 'W55', teamId: null },
  W56: { id: 'W56', teamId: null },
  W57: { id: 'W57', teamId: null },
  W58: { id: 'W58', teamId: null },
  W59: { id: 'W59', teamId: null },
  W60: { id: 'W60', teamId: null },
  W61: { id: 'W61', teamId: null },
  W62: { id: 'W62', teamId: null },
  L61: { id: 'L61', teamId: null },
  L62: { id: 'L62', teamId: null },
  W63: { id: 'W63', teamId: null },
  W64: { id: 'W64', teamId: null },
};

const initialState = JSON.parse(localStorage.getItem('picks')) || emptyPicks;

const picksSlice = createSlice({
  name: 'picks',
  initialState,
  reducers: {
    setPick: (state, { payload }) => {
      const p = { [payload.id]: payload };
      return { ...state, ...p };
    },
    setPicks: (state, { payload }) => {
      const ps = payload.reduce((acc, cur) => ({ ...acc, [cur.id]: cur }), {});
      return { ...state, ...ps };
    },
  },
});

export const { setPick, setPicks } = picksSlice.actions;

export default picksSlice.reducer;
